import { configService } from "../utils/ConfigService";
import { getService } from "../utils/Request";

interface forgotpassProps {
  username: string | number;
  mobile: string | number;
}
export function forgotpassword(data: forgotpassProps) {
  const profileEndpoint = configService.getProfileEndpoint();
  return getService()({
    url: `/Account/ForgotPassword?username=${data.username}&mobile=${data.mobile}`,
    method: "post",
    baseURL: profileEndpoint + "/api",
  });
}
